import { render, staticRenderFns } from "./coupon-rules.vue?vue&type=template&id=380c10f0&scoped=true"
import script from "./coupon-rules.vue?vue&type=script&lang=js"
export * from "./coupon-rules.vue?vue&type=script&lang=js"
import style0 from "./coupon-rules.vue?vue&type=style&index=0&id=380c10f0&prod&scoped=true&lang=css"
import style1 from "./coupon-rules.vue?vue&type=style&index=1&id=380c10f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380c10f0",
  null
  
)

export default component.exports